import React, { useState, useEffect } from 'react'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { routes } from '../../../constantes/routes'
import { positionsActions } from '../../../actions/positionsActions'
import NewPositionsModal from './NewPositionsModal'
import PositionsList from './PositionsList'
import PlusBtn from '../../buttons/PlusBtn'
import {
  swalAlertError,
  swalSuccessGeneral,
  swalAlertIsConfirm,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import { onSubmitText } from '../../../constantes/onSubmitText'
import EditPositionModal from './EditPositionModal'
import Search from '../../common/Search'
import Header from '../../header/Header'
import validators from '../../../utils/validationsRegEx'
import { update } from 'lodash'
import { positionsTypes } from '../../../constantes/actionTypes'
import { swalMssgs } from '../../../constantes/swalMssgs'

const PositionsContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const allPositions = useSelector((state) => state.positions)

  const [newPosition, setNewPosition] = useState({ nombre: '' })
  const [editPosition, setEditPosition] = useState('')
  const [items, setItems] = useState(allPositions)

  const [modalIsOpen, setIsOpen] = useState({
    createModal: false,
    editModal: false,
  })

  const dispatch = useDispatch()
  const getAllPositions = () => dispatch(positionsActions.getAllPositions())
  const newPositions = (position) =>
    dispatch(positionsActions.newPosition(position))
  const editPositions = (position) =>
    dispatch(positionsActions.updatePosition(position))
  const deletePosition = (idPosition) =>
    dispatch(positionsActions.deletePositionById(idPosition))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getAllPositions()
    }
  }, [])

  useEffect(() => {
    setItems(allPositions)
  }, [allPositions])

  const openNewModal = () => {
    setIsOpen({
      createModal: true,
      editModal: false,
    })

    setNewPosition({ nombre: '' })
  }

  const openEditModal = (idPosition) => {
    setIsOpen({
      createModal: false,
      editModal: true,
    })
    setEditPosition(items.find((item) => item.id_TipoCargo === idPosition))
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleNew = async (event) => {
    event.preventDefault()
    try {
      const response = await newPositions(newPosition)
      if (positionsTypes.NEW_POSITION_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleRemove = async (idPosition) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar este cargo?',
      )
      if (alert.isConfirmed) {
        const response = await deletePosition(idPosition)
        if (positionsTypes.DELETE_POSITION_SUCCESS === response.type)
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleEdit = async (event) => {
    event.preventDefault()
    try {
      const response = await editPositions(editPosition)
      if (positionsTypes.UPDATE_POSITION_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleChangeNew = (e) => {
    const value = e.target.value
    const name = e.target.name
    setNewPosition({ [name]: value })
  }

  const handleChangeEdit = (e) => {
    const value = e.target.value
    const name = e.target.name
    setEditPosition((pos) => ({ ...pos, [name]: value }))
  }

  const validateFormNew = () => {
    return validators.hasValue(newPosition.nombre)
  }

  const validateFormEdit = () => {
    return validators.hasValue(editPosition.nombre)
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const onChangeSearch = (value) => {
    const newItems = allPositions.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header text={'Cargos'} route={toBackoffice} backBtn={true} />
          <div className='filter__wrap mb-80'>
            <Search
              onChangeSearch={onChangeSearch}
              placeholder='Buscar por nombre...'
            />
            <div className='add__action__rigth__side'>
              <button className='action-button' onClick={openNewModal}>
                <PlusBtn />
                <span>Nuevo cargo</span>
              </button>
            </div>
          </div>
          <PositionsList
            allPositions={items}
            handleRemove={handleRemove}
            openEditModal={openEditModal}
          />
          <NewPositionsModal
            newPosition={newPosition}
            modalIsOpen={modalIsOpen.createModal}
            closeModal={closeModal}
            handleSubmit={handleNew}
            handleChange={handleChangeNew}
            validateForm={validateFormNew}
            textBtn={onSubmitText.Crear}
          />

          <EditPositionModal
            modalIsOpen={modalIsOpen.editModal}
            closeModal={closeModal}
            getAllPositions={getAllPositions}
            handleSubmit={handleEdit}
            handleChange={handleChangeEdit}
            inputs={editPosition}
            validateForm={validateFormEdit}
            textBtn={onSubmitText.Guardar}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(PositionsContainer)
